import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { navigateTo, UserPasswordForm, useGetViewer } from '@amber-ui/core';

function UserPasswordRoute() {
  const { viewer } = useGetViewer();

  const onSubmitSuccess = useCallback(() => {
    navigateTo('/grain_bin/dashboard');
  }, []);

  if (!viewer) return null;

  return (
    <UserPasswordForm
      token={null}
      user_id={viewer.user.user_id}
      onSubmitSuccess={onSubmitSuccess}
    />
  );
}

export const Route = createFileRoute('/_auth/user/password')({
  component: UserPasswordRoute,
});
